/**
 * Created by Miguel on 23/05/2017
 */
import { Component, OnInit,   } from '@angular/core';
import {UserService} from "../../../services/user.service";
import { AppDataService }  from '../../../services/app-data.service';
import { CompanyService }  from '../../../services/company.service';
import { TranslationService } from '../../../services/translation.service';

declare var $ : any;
declare var Swal: any
declare var JitsiMeetExternalAPI;

@Component({
    selector : 'tutorial-modal',
    templateUrl:'tutorial.html',
    providers  : [],  
})
export class TutorialComponent implements OnInit {

  public api;


  public tutorialText=[];
  public tutorialImage=[];

  public tutorial1Btn=false

  public tutorial1=true;
  public tutorialIndex=0;
  public tutorialTxt='';
  public tutorialImg='';
  public chatTutorial=true;
  public videoTutorial=true;
  public controlsTutorial=true;
  public moveTutorial=true;
    public ngOnInit() : any {

    }

    constructor( public _appData : AppDataService,private _companyService : CompanyService,private _auth : UserService,public translate: TranslationService) {
      this._appData.tutorial=false;   



      
      this.tutorialIndex=0;
    
      setTimeout(()=>{
        this._appData.tutorial=true;   
        this.tutorialText=[this.translate.instant('TUTORIAL_COMPONENT_1'),this.translate.instant('TUTORIAL_COMPONENT_2'),this.translate.instant('TUTORIAL_COMPONENT_3')];
        this.tutorialImage=['/assets/gifs/videoconf.gif','/assets/gifs/headphone.gif','/assets/gifs/rotate.gif']; 
        this.tutorialTxt=this.tutorialText[0];
        this.tutorialImg=this.tutorialImage[0];
  
        let querySelector=document.querySelector('#tutorialTest')
        const options = {
          roomName: 'teste',
          width: '1%',
          height: '1%',
          configOverwrite: { 
            disableDeepLinking: true, 
            prejoinPageEnabled: false,
            startWithAudioMuted:false,
            startWithVideoMuted:false
           },
          interfaceConfigOverwrite:{ 
            SHOW_JITSI_WATERMARK: false,
            JITSI_WATERMARK_LINK: 'https://liveparty.com.br',
            SHOW_WATERMARK_FOR_GUESTS: false,
            SHOW_BRAND_WATERMARK: false,
            APP_NAME: 'LIVEPARTY',
            TOOLBAR_BUTTONS: [],            
          SETTINGS_SECTIONS: [ 'devices', 'language', 'moderator', 'profile'],
          MOBILE_DOWNLOAD_LINK_ANDROID: 'https://play.google.com/store/apps/details?id=com.coolkids',
          ANDROID_APP_PACKAGE: 'com.viplistas',
          NATIVE_APP_NAME: 'liveparty',
          enableCalendarIntegration: false,
          BRAND_WATERMARK_LINK: 'https://liveparty.com.br',
          DEFAULT_REMOTE_DISPLAY_NAME: 'Usuario novo',
          DEFAULT_LOCAL_DISPLAY_NAME: 'Eu',
        },
        userInfo: {
          displayName: 'Usuario Novo'
        },
        parentNode: querySelector
  
  
       };
        this.api = new JitsiMeetExternalAPI('meet.jit.si',options);
        this.api.addEventListener("micError", (evt)=>{
          this.tutorialTxt="O seu microfone está com problemas. Falar no metaverso é importante para sua experiência. Clique em 'OK' para corrigir o problema.";
          this.tutorialImg=this.tutorialImage[0]; 
          this.tutorialIndex=-1;
          this.api.dispose();
        })
  
      },15000)
    }
    public testAudio(){

    }
    public clickOk(){
      this.tutorialIndex=this.tutorialIndex+1;
      if (this.tutorialIndex==1){
        this.testAudio();
        this.tutorialTxt=this.tutorialText[1];
        this.tutorialImg=this.tutorialImage[1]; 

      }
      if (this.tutorialIndex==0){
        let domain=window.location.origin
        window.location.href=domain+"/welcome?event="+this._appData.event.id+'&room='+this._appData.room.id;
      }
      if (this.tutorialIndex==2){
        this.tutorialTxt=this.tutorialText[this.tutorialIndex];
        this.tutorialImg=this.tutorialImage[this.tutorialIndex]; 
       }
      if (this.tutorialIndex==3){
        this.tutorial1=false;
        this.api.dispose();
        this.api=null
        this.closeTutorial1();
        
      }

    }

    public closeTutorial1(){
      this._appData.tutorial=false;
      Swal.fire({
        title:this.translate.instant('REGISTER'),
        text:this.translate.instant('TUTORIAL_COMPONENT_4'),
        confirmButtonText: this.translate.instant('REGISTER'),
        cancelButtonText:this.translate.instant('CANCEL'),
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false, 
        }).then((result) => {
          if (result.dismiss=='backdrop') {}
          else if (result.dismiss=='close') {}
          else if (result.dismiss=='cancel'){}
          else{
            $('#registerSocialModal').modal('show')
            this._appData.tiping=true;
    
          }
      })

    }
    public sendIframeMessage(messageKind){
      var iframe = document.getElementById('gameFrame');
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage(messageKind, "*");
    }
    public clickChat(){
      $('#chatMessageInput').focus();
      this.chatTutorial=false;

    }
    public clickVideo(){
      $('#videoImage1').click();
      this.videoTutorial=false;

    }
    public clickControls(){
      if (isNaN(this._appData.instagramUser.uid)){
        let idx=$("#profileModal")
        idx.modal("show");
      }
      else{
        $('#registerSocialModal').modal("show")
      }
      this.controlsTutorial=false;

    }
    public clickMove(){
      this.moveTutorial=false;

    }


}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/tutorial/tutorial.ts